// extracted by mini-css-extract-plugin
export var label = "nextroutesection-module--label--f50cb";
export var mapIcon = "nextroutesection-module--mapIcon--a3501";
export var sectionWrapper = "nextroutesection-module--sectionWrapper--d5131";